import React from 'react';

export default function AccessDenied() {
  return (
    <blockquote
      style={{ margin: '15px', padding: '30px' }}
      className="custom-blockquote error"
    >
      <div className="row">
        <span className="k-input-icon">
          <span
            style={{ fontSize: '26px', paddingBottom: '13px' }}
            className="k-icon k-font-icon k-i-warning"
          />
        </span>
        <h3 style={{ marginLeft: '10px' }}>Accès refusé</h3>
      </div>
    </blockquote>
  );
}
